/*
 * @Author: benaozhi
 * @Date: 2020-01-03 18:29:42
 * @LastEditTime: 2022-01-29 15:29:34
 * @Description:
 */
import store from 'store'
import { strictFetch } from './http'
import { USER_INFO } from '../config/const'
import qs from 'qs'
// 登录
export async function login({ username, password }) {
  return strictFetch({
    url: '/login/testUserIn',
    method: 'POST',
    params: { username, password },
  })
}
export async function postLogout(data) {
  return strictFetch({
    url: '/login/testUserLogout',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 获取用户信息
export async function getUserInfo({ uid }) {
  const { data, code } = await strictFetch({
    url: '/user/getOne',
    method: 'GET',
    params: { uid },
  })

  if (code === 0) {
    store.set(USER_INFO, data)
  }
}
/**
 * 注册页
 */
// 用户注册
export async function postCheckLoginName(data) {
  return strictFetch({
    url: '/testUser/checkLoginName',
    method: 'POST',
    data: qs.stringify(data)
  })
}
export async function postUserRegister(data) {
  return strictFetch({
    url: '/testUser/register',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 获取单个前台用户接口
export async function postUserGetOne(data) {
  return strictFetch({
    url: '/index/getUserInfo',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 保存/修改前台用户接口
export async function postUserSave(data) {
  return strictFetch({
    url: '/testUser/save',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 查询字典
export async function postGetListByCode(data) {
  return strictFetch({
    url: '/dict/getListByCode',
    method: 'POST',
    data: qs.stringify(data)
  })
}
/**
 * 忘记密码页
 */
// 检测账号
export async function postCheckAccount(data) {
  return strictFetch({
    url: '/testUser/checkAccount',
    method: 'POST',
    data: qs.stringify(data)
  })
}
export async function postCheckCard(data) {
  return strictFetch({
    url: '/testUser/checkCard',
    method: 'POST',
    data: qs.stringify(data)
  })
}
export async function postUpdatePwd(data) {
  return strictFetch({
    url: '/testUser/updatePwd',
    method: 'POST',
    data: qs.stringify(data)
  })
}

export async function postGetUnitList(data) {
  return strictFetch({
    url: '/unit/getList',
    method: 'POST',
    data: qs.stringify(data)
  })
}
export async function postGetProtocol(data) {
  return strictFetch({
    url: '/protocol/getOne',
    method: 'POST',
    data: qs.stringify(data)
  })
}
export async function postSendSmsCode(data) {
  return strictFetch({
    url: '/testUser/sendSmsCode',
    method: 'POST',
    data: qs.stringify(data)
  })
}
export async function postCheckSmsCode(data) {
  return strictFetch({
    url: '/testUser/checkSmsCode',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 前台用户补录
export async function postUserSupply(data) {
  return strictFetch({
    url: '/testUser/userSupply',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 机构无需分页查询列表
export async function postGetOrganizationList(data) {
  return strictFetch({
    url: '/organization/getList',
    method: 'POST',
    data: qs.stringify(data)
  })
}
/**
 * 收录
 */

// 获取用户信息
export async function getGetUserInfo(params) {
  return strictFetch({
    url: '/testUser/getUserInfo',
    method: 'GET',
    params,
  })
}

